import React,{useState} from "react";
import { IoMdClose } from "react-icons/io";
import { CiSearch } from "react-icons/ci";
const Search = (props) => {
    const [Search,SetSearch] = useState("");
    return (
        <>
            <div className="Search">
                {props.Searchvalue?.length === 0 && <CiSearch />}
                <input type="text" placeholder={props.placeholder ? props.placeholder : "Search..." } value={props.Searchvalue}
                    style={{ paddingLeft: props.Searchvalue?.length > 0 ? '20px' : '30px', }}
                    
                    onChange={(e) =>{ SetSearch(e.target.value);props.onChange(e.target.value);}}
                />
                {props.Searchvalue?.length > 0 && <IoMdClose onClick={() => { SetSearch("");props.onChange("") }} />}
            </div>
        </>
    )
};
export default Search;